var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-container"},[_c('the-nav-bar',{ref:"nav",attrs:{"title":_vm.$t('newSettings.kycVideo.katoonTitle')}}),_c('video-player',{attrs:{"video-id":_vm.videoId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }